import i18next from 'i18next'
import { resources } from './resources'

export const i18n = i18next.createInstance({
  resources,
  fallbackLng: 'en',
  lng: 'en',
  showSupportNotice: false,

  interpolation: {
    escapeValue: false,
    format: function (value, format) {
      if (format === 'rounded') return Math.round(value)
      return value
    }
  }
})

i18n.init()
